import { api } from './client'

export async function listCustomers() {
  const { data } = await api.get('/customers')
  return data
}

export async function createCustomer({
  name,
  notes,
  template = 'it',
  company_owner_representative = null,
  it_manager_system_administrator = null,
}) {
  const { data } = await api.post('/customers', {
    name,
    notes,
    template,
    company_owner_representative,
    it_manager_system_administrator,
  })
  return data
}

export async function getCustomer(id) {
  const { data } = await api.get(`/customers/${id}`)
  return data
}

export async function updateCustomer(id, body) {
  const { data } = await api.patch(`/customers/${id}`, body)
  return data
}

export async function deleteCustomer(id) {
  await api.delete(`/customers/${id}`)
}

export async function fetchCustomerLogoBlob(id) {
  const { data } = await api.get(`/customers/${id}/logo`, {
    responseType: 'blob',
  })
  return data
}

export async function uploadCustomerLogo(id, file) {
  const body = new FormData()
  body.append('file', file)
  const { data } = await api.post(`/customers/${id}/logo`, body, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data
}

export async function deleteCustomerLogo(id) {
  const { data } = await api.delete(`/customers/${id}/logo`)
  return data
}

export async function listCategories(customerId) {
  const { data } = await api.get(`/customers/${customerId}/categories`)
  return data
}

export async function setCategoryHidden(customerId, slug, hiddenFromCustomer) {
  const { data } = await api.patch(`/customers/${customerId}/categories/${slug}`, {
    hidden_from_customer: hiddenFromCustomer,
  })
  return data
}

export async function createCategory(customerId, { title, kind, columns, icon, parent_slug }) {
  const body = { title, kind }
  if (kind === 'table' && columns) body.columns = columns
  if (icon) body.icon = icon
  if (parent_slug) body.parent_slug = parent_slug
  const { data } = await api.post(`/customers/${customerId}/categories`, body)
  return data
}

export async function updateCategory(customerId, slug, body) {
  const { data } = await api.patch(`/customers/${customerId}/categories/${slug}`, body)
  return data
}

export async function reorderCategories(customerId, slugs) {
  const { data } = await api.put(`/customers/${customerId}/categories/reorder`, { slugs })
  return data
}

export async function deleteCategory(customerId, slug) {
  await api.delete(`/customers/${customerId}/categories/${slug}`)
}

export async function listRows(customerId, slug, { tableKey } = {}) {
  const params = {}
  if (tableKey != null && tableKey !== '') params.table_key = tableKey
  const { data } = await api.get(`/customers/${customerId}/categories/${slug}/rows`, {
    params,
  })
  return data
}

export async function createRow(customerId, slug, body) {
  const { data } = await api.post(`/customers/${customerId}/categories/${slug}/rows`, body)
  return data
}

export async function importRows(customerId, slug, { tableKey = '', rows }) {
  const { data } = await api.post(`/customers/${customerId}/categories/${slug}/rows/import`, {
    table_key: tableKey || '',
    rows,
  })
  return data
}

export async function updateRow(customerId, slug, rowId, body) {
  const { data } = await api.patch(
    `/customers/${customerId}/categories/${slug}/rows/${rowId}`,
    body,
  )
  return data
}

export async function deleteRow(customerId, slug, rowId) {
  await api.delete(`/customers/${customerId}/categories/${slug}/rows/${rowId}`)
}

export async function getPage(customerId, slug) {
  const { data } = await api.get(`/customers/${customerId}/categories/${slug}/page`)
  return data
}

export async function savePage(customerId, slug, contentHtml) {
  const { data } = await api.put(`/customers/${customerId}/categories/${slug}/page`, {
    content_html: contentHtml,
  })
  return data
}

export async function listDashCustomers() {
  const { data } = await api.get('/dash/customers')
  return data
}

export async function listDevices(customerId, slug) {
  const { data } = await api.get(`/customers/${customerId}/categories/${slug}/devices`)
  return data
}
